import { DB } from '~/plugins/firebase-plugin.js';
const moment = require('moment');

const types = {
    SET_ACTIVITY_SIZE: 'SET_ACTIVITY_SIZE',
    SET_ACTIVITY: 'SET_ACTIVITY',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_IS_LOADING: 'SET_IS_LOADING',
    SET_SHOW_DETAILS: 'SET_SHOW_DETAILS',
    SET_CUSTOMERS: 'SET_CUSTOMERS',
    SET_SELECTED_CUSTOMER: 'SET_SELECTED_CUSTOMER',
};

export const state = () => ({
    isLoading: false,
    error: null,
    activity: [],
    activitySize: 0,
    customers: [],
    selectedCustomer: null,
});

export const getters = {
    isLoading(state) {
        return state.isLoading;
    },
    error(state) {
        return state.error;
    },
    activity(state) {
        return state.activity;
    },
};

export const mutations = {
    [types.SET_ERROR] (state, error) {
        state.error = error;
    },
    [types.CLEAR_ERROR] (state) {
        state.error = null;
    },
    [types.SET_IS_LOADING] (state, isLoading) {
        state.isLoading = isLoading;
    },
    [types.SET_ACTIVITY] (state, activity) {
        state.activity = activity;
    },
    [types.SET_ACTIVITY_SIZE] (state, activitySize) {
        state.activitySize = activitySize;
    },
    [types.SET_SHOW_DETAILS] (state, id) {
        const notActive = state.activity.filter(activity => activity.id !== id);
        notActive.forEach(activity => {
            activity._showDetails = false;
        });

        // To create a toggle effect, let's do something.
        const selectedActivity = state.activity.find(activity => activity.id === id);
        selectedActivity._showDetails = !selectedActivity._showDetails;
    },
    [types.SET_CUSTOMERS] (state, customers) {
        state.customers = customers;
    },
    [types.SET_SELECTED_CUSTOMER] (state, customer) {
        state.selectedCustomer = customer;
    },
};

export const actions = {
    async getCompanies({commit}, {user}) {
        const data = await this.$axios.$post('/api/admin/list-customers', {user});
        commit(types.SET_CUSTOMERS, data.customers);
    },
    async getCompanyActivity({commit, state}, { guid, page, perPage, startAfter }) {
        commit(types.CLEAR_ERROR);
        commit(types.SET_IS_LOADING, true);

        if (!guid) {
            commit(types.SET_ERROR, 'You need to provide a customer to get activity for.');
            return;
        }

        // Customer Activity is a sub-collection of a collection.
        const customersCollection = DB.collection('customers');
        const customerDocument = customersCollection.doc(guid);
        const customerActivityCollection = customerDocument.collection('activity');
        const limit = page * perPage;
        const activityDocs = [];

        if (state.selectedCustomer !== guid) {
            commit(types.SET_SELECTED_CUSTOMER, guid);

            // To prevent unnecessary reads, don't get the SIZE if we already have the count
            // for this customer.
            const totalCustomerActivityRef = await customerActivityCollection.get();
            const  totalCustomerActivitySize = totalCustomerActivityRef.size;
            commit(types.SET_ACTIVITY_SIZE, totalCustomerActivitySize);
        }

        let customerActivityRef;
        if(startAfter) {
            const lastActivity = await customerActivityCollection.doc(startAfter.id).get();
            customerActivityRef = await customerActivityCollection.orderBy('time', 'desc').startAfter(lastActivity).limit(perPage).get();
        } else {
            customerActivityRef = await customerActivityCollection.orderBy('time', 'desc').limit(limit).get();
        }

        for (let index = 0; index < customerActivityRef.size; index++) {
            const activityDoc = customerActivityRef.docs[index];
            const { action, event, time, user, details } = activityDoc.data();

            activityDocs.push({
                id: activityDoc.id,
                event: action || event,
                time: moment(time.toDate()).format('lll'),
                details,
                _showDetails: false,
                user: user ? user.id : '', // Using the user.id for the e-mail saves us a READ operation
            });
        }

        commit(types.SET_IS_LOADING, false);
        commit(types.SET_ACTIVITY, activityDocs);
    },
    setShowDetails({commit}, id) {
        // This will set _showDetails to true but false for all other activities.
        commit(types.SET_SHOW_DETAILS, id);
    }
};

export const strict = false;
